class Components extends React.Component {
  render() {
    return(
      <ul className="section__items--components">
        <CollapserDemo />
        <DialogDemo />
        <ModalDemo />
        <TooltipDemo />
      </ul>
    )
  }
};
